import _ from 'lodash';
import { log } from '@swiper/core';
import { Service } from './Service';

export class PeopleService extends Service {

  get name() { return 'people'; }

  async find( { query, ...params } ) {
    log.debug( 'PeopleService#find', query, params );
    const key = _.keys( query ).sort().join( '-' );
    console.log( 'FIND KEYS', key );

    const guests_svc = this.app.service( 'guests' );
    const members_svc = this.app.service( 'members' );

    const guests = await guests_svc.find( { query } );
    if ( key === 'membershipId' ) { // Just the recent entries
      return guests.reverse().slice( 0, 10 );
    } else if ( key === 'membershipId-name' ) {
      const children = await members_svc.find( { query : {
        name  : query.name,
        type  : 'child',
      } } );
      const people = _.flatten( [ guests, children ] );
      return _.uniqWith( people, ( x, y ) => {
        return x.memberId && y.memberId && x.memberId === y.memberId;
      } );
    } else {
      this.throw( 'BadRequest', `Unable to find people with keys ${key}` );
    }
  }

}

export const hooks = {
  before  : { all : [ 'auth' ] },
};
